import { ExperimentsClient } from '@novacredit/frontend-common/experiments';
import { getOverridesFromQueryParams } from '@novacredit/frontend-common/experiments-frontend';
import { getOrCreateNovaAnonymousId } from '@novacredit/frontend-common/utils/novaAnonymousId';

import tracker from './tracking';

const event = new Event('NovaExperimentsLoaded');

declare global {
	interface Window {
		NovaExperiments: { client: ExperimentsClient };
	}
}

export const initializeNovaExperiments = () => {
	window.NovaExperiments = {
		client: new ExperimentsClient({
			bucketingId: getOrCreateNovaAnonymousId(),
			trackingFn: (experimentName, variant) => {
				tracker.track('nova.client.EXPERIMENT_STARTED', {
					'Experiment name': experimentName,
					'Variant name': variant,
				});
			},
			overrides: getOverridesFromQueryParams(),
		}),
	};

	window.dispatchEvent(event);
};
